import React from 'react'
import { Link, useNavigate } from 'react-router-dom';
import white_left_next_page_arow from "../../assets/images/white_left_next_page_arow.svg";

const BackLink = (props) => {
    const navigation  =useNavigate()
    
    const urlLink = props.urlLink? props.urlLink :'dashboard'
    return (
        <h1 className='Back_to_Dashboard'>
            <img src={white_left_next_page_arow} onClick={() => navigation(`/${urlLink}`, { state: { from: 'loginChart' }})} style={{ cursor: 'pointer' }} className="Dashboard_icon" loading="lazy" alt="" />
            <Link to={`/${urlLink}`}>
                {props.heading?props.heading:'Back to Dashboard'}
            </Link>
        </h1>
    )
}

export default BackLink